import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class IsAdminGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router, private toastr: ToastrService) { };

  canActivate() {

    if (this.loginService.getRole() != 'admin') {
      this.showInfoMessage('No tienes permisos para acceder como administrador', 'Usuario no autorizado');
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }

  showSuccessMessage(mensaje: string, titulo: string) {
    this.toastr.success(mensaje, titulo);
  }

  showErrorMessage(mensaje: string, titulo: string) {
    this.toastr.error(mensaje, titulo);
  }

  showInfoMessage(mensaje: string, titulo: string) {
    this.toastr.info(mensaje, titulo);
  }

  showWarningMessage(mensaje: string, titulo: string) {
    this.toastr.warning(mensaje, titulo);
  }

}
